import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import AccountProposalReviewTemplate from 'Views/Page/Content/Templates/AccountProposalReviewTemplate/Content';

const useStyles = buildUseStyles('AccountProposalReviewStepTemplate', () => ({
  root: {},
}));

const AccountProposalReviewStepTemplate = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      layout={AccountProposalReviewTemplate}
      primaryActionLabel="Accept & Continue"
    />
  );
};

AccountProposalReviewStepTemplate.defaultProps = {
  className: '',
};

AccountProposalReviewStepTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountProposalReviewStepTemplate;
